import { createContext, useContext, useEffect, useState } from 'react'
import {jwtDecode} from 'jwt-decode'
import { Outlet } from 'react-router-dom'
import apiAxios from '../../api/api'
import Login from '../../pages/Login'

const AuthContext = createContext()

export const useAuth = () => {
    return useContext(AuthContext)
}

const PrivateRoutes = ({ children }) => {
    // let auth = { 'token': localStorage.token }

    const [authState, setauthState] = useState({
        accessToken: null,
        // refreshToken: null,
        user_id: null,
        is_admin: null,
        authenticated: false,
        userInfo: {}
    })
    useEffect(() => {
        const loadToken = async () => {
            const accessToken = localStorage?.getItem('token')
            // const refreshToken = localStorage?.getItem('refreshToken')
            const accessInfo = !!accessToken ? jwtDecode(accessToken) : null

            try {
              
                if (!!accessInfo) {
                    // (jwtDecode(token)?.email === localStorage?.getItem('user') && jwtDecode(token)?.user_ui == localStorage?.getItem('user_ui')) &&
                    setauthState({
                        accessToken: accessToken||null,
                        user_id: accessInfo?.user_id||null,
                        is_admin: accessInfo?.user_ui||null,
                        authenticated: !!accessInfo||false,
                        userInfo: accessInfo||{}
                    })
                }

            } catch (error) {
                console.log('eeee', error);
                localStorage.clear()
                setauthState({
                    accessToken: null,
                    // refreshToken: null,
                    user_id: null,
                    is_admin: null,
                    authenticated: false,
                })
                return error
            }
            // window.location.replace('/')

        }
        loadToken()
    }, [localStorage?.getItem('token')])

    const login = async (loginInfo) => {

        try {
            const res = await apiAxios.post('/login', loginInfo)
            if (res.status === 200) {
                // window.location.replace('/')
                
                setauthState({
                    accessToken: await res?.headers.accessToken,
                    user_id: res?.data.user_id,
                    is_admin: res?.data.is_admin,
                    // refreshToken: res?.headers.refreshToken,
                    // position: jwtDecode(localStorage?.getItem('token').position),
                    // permissions: jwtDecode(localStorage?.getItem('token').permissions),
                    authenticated: true
                })

                localStorage.setItem('token', await res?.headers.accesstoken)
                localStorage.setItem('refreshToken', await res?.headers.refreshtoken)
                localStorage.setItem('user_id', res?.data.user_id)
                localStorage.setItem('name', res?.data.name)
                localStorage.setItem('surname', res?.data.surname)
                localStorage.setItem('spooken', await res?.headers.spooken)
            }
            return res
        } catch (error) {
            // console.error(error?.response?.data);
            return error
        }
    }

    const logOut = () => {
        localStorage.clear()
        setauthState({
            accessToken: null,
            // refreshToken: null,
            user_id: null,
            is_admin: null,
            authenticated: false
        })
        window.location.replace('/')
    }

    const value = {
        onLogin: login,
        onLogout: logOut,
        authState
    }

    return (

        <AuthContext.Provider value={value}>
            {children}
            {authState?.authenticated ? 
           
                        <Outlet />
                   
             : <Login />}
        </AuthContext.Provider>


    );
}

export { AuthContext, PrivateRoutes };